import { Component } from 'preact'
import SingleComments from './Comment'
import i18n from '../../i18n'
import { getInitialState } from '../../helpers/state'
import { ReviewForm, Modal } from '../'
import {
  OPEN,
  CLOSED,
  AGGRESSIVE_CTA
} from '../constants'
import './Comments.scss'

const ORIGINAL = 'ORIGINAL'
const REVIEWS = 'REVIEWS'

class CommentsWrapper extends Component { // eslint-disable-line
  constructor(props) {
    super(props)

    this.initialData = getInitialState(props.items[0].id)

    this.state = {
      activeTab: ORIGINAL,
      tabs: [
        { label: i18n('Comments'), id: ORIGINAL },
        { label: i18n('Reviews'), id: REVIEWS },
      ],
      localRating: this.initialData ? this.initialData.rating : null,
      status: CLOSED,
    }
    this.handleUpdateRatings = this.handleUpdateRatings.bind(this)

    // We shoud only support the standalone form
    // if the comments wrapper has exactly one card,
    // the aggressive CTA setting is enabled, and
    // if the user has _not_ left a rating for this
    // card already.
    this.supportStandaloneForm =
      AGGRESSIVE_CTA &&
      props.items.length === 1 &&
      !getInitialState(props.items[0].id)
  }

  componentDidMount() {
    const { el } = this.props
    el.style.marginTop = 0
    el.style.paddingTop = 0

    // This should always exist unless someone put in a bad selector
    if(el.firstElementChild) {
      el.firstElementChild.style.marginTop = 0
      el.firstElementChild.style.paddingTop = 0
    }
  }

  /**
   * When the component updates its tab, toggle visibility of original mounted element.
   */
  componentDidUpdate(_, prevState) {
    const { el } = this.props
    const { activeTab } = this.state
    if (prevState.activeTab === activeTab) {
      return
    }
    const shouldDisplay = activeTab === ORIGINAL
    el.style.display = shouldDisplay ? 'block' : 'none'
  }

    /**
   * Callback after form submission. We close the modal and update ratings.
   * @param {number} rating    New rating
   * @param {object} previous  Locally-cached rating
   */
  handleUpdateRatings(review) {
    this.setState({ status: CLOSED })
    if (this.initialData) {
      const { id, onUpdate } = this.props
      onUpdate(id, review)
    } else {
      const { id, onAdd } = this.props
      onAdd(id, {
        ...review,
        // Mimics the timestamp that would be created via the PHP backend
        created: Math.floor(Date.now() / 1000)
      })
    }
  }

  render() {
    const { items } = this.props
    const {
      activeTab,
      tabs,
      status,
      localRating,
    } = this.state

    return (
      <div class="mv-comments-wrap">
        {!this.supportStandaloneForm && (
          <h2>{i18n('COMMENTS_AND_REVIEWS')}</h2>
        )}

        {this.supportStandaloneForm && (
          <div class="mv-comments-standalone-form">
            <div class="mv-comments-standalone-form-left">
              <h2>{i18n('COMMENTS_AND_REVIEWS')}</h2>
              <h3>
                {i18n('DID_YOU_MAKE_THIS')}
              </h3>
            </div>

            <div class="mv-comments-standalone-form-right">
              <ReviewForm
                id={this.props.items[0].id}
                initial={this.initialData}
                rating={0}
                onSubmit={this.handleUpdateRatings}
              />
            </div>
          </div>
        )}

        <nav class="mv-comments-nav">
          <ul>
            {tabs.map(({ label, id }) => (
              <li
              key={id}
              onClick={() => this.setState({ activeTab: id })}
              class={id === activeTab ? 'mv-active' : ''}
              >
                {label}
              </li>
            ))}
            {!this.supportStandaloneForm && (
              <li
                class="mv-create-button mv-create-review-button"
                onClick={() => {
                  this.setState({ status: OPEN })
                }}
                style={{ cursor: 'pointer' }}
              >
                Write a review
              </li>
            )}
          </ul>
        </nav>

        {status === OPEN && (
          <Modal onClose={() => this.setState({ status: CLOSED })}>
            <ReviewForm
              id={this.props.items[0].id}
              initial={this.initialData}
              rating={localRating}
              onSubmit={this.handleUpdateRatings}
            />
          </Modal>
        )}

        {activeTab === REVIEWS && (
          items.map(item => (
            <SingleComments
              id={item.id}
              onAdd={this.props.onAdd}
              onUpdate={this.props.onUpdate}
              onLoad={this.props.onLoad}
              key={item.id}
              data={item}
            />
          ))
        )}

      </div>
    )
  }
}

CommentsWrapper.defaultProps = {
  items: [],
}

export default CommentsWrapper
